<template>
  <div class="user_container">
    <div class="container">
      <div class="header" v-if="token == '10005038'">
        <div :class="{ active: tabIndex == 1 }" @click="tabClick(1)">
          用车区域维护
        </div>
        <div :class="{ active: tabIndex == 2 }" @click="tabClick(2)">
          区域厂务权限
        </div>
      </div>
      <div class="content" v-if="tabIndex == 1">
        <div class="filed_label">
          用车区域 <span>（温馨提示：切换区域时请提交新添加的车辆）</span>
        </div>
        <div class="filed_input">
          <el-select v-model="valueRegion" placeholder="请选择" @change="changeRegion">
            <el-option
              v-for="item in optionRegion"
              :key="item.id"
              :label="item.zoneName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="filed_label">用车单价</div>
        <div class="filed_input">
          <el-input v-model="valueNumber" placeholder="请输入" type="number">
            <template slot="append">元/公里</template>
          </el-input>
        </div>
        <div class="filed_label">添加区域车辆</div>
        <div class="filed_input">
          <el-select v-model="valueCar" placeholder="请选择">
            <el-option
              v-for="item in optionCar"
              :key="item.id"
              :label="item.carBrand"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button @click="pushTable">添加</el-button>
        </div>
        <div class="filed_label">区域车辆信息</div>
        <div class="filed_table">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            :max-height="height"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="carBrandText"
              label="车辆信息"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="zoneName" label="所属区域" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="70">
              <template slot-scope="scope">
                <img
                  @click="handleDel(scope.row)"
                  src="@/assets/car/barrel.png"
                  alt=""
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="content" v-if="tabIndex == 2">
        <div class="filed_label">厂务人员</div>
        <div class="filed_input">
          <el-select
            v-model="valuePeople"
            placeholder="请选择"
            @change="changePeople"
          >
            <el-option
              v-for="item in optionPeople"
              :key="item.username"
              :label="item.nickname"
              :value="item.username"
            >
            </el-option>
          </el-select>
        </div>
        <div class="filed_label">所属部门</div>
        <div class="filed_input">
          <el-input v-model="valueDepament" placeholder="请选择" readonly>
            <!-- <el-option
              v-for="item in optionDepament"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option> -->
          </el-input>
        </div>
        <div class="filed_label">管理区域</div>
        <div class="filed_input">
          <el-select v-model="valueManage" placeholder="请选择" multiple>
            <el-option
              v-for="item in optionManage"
              :key="item.id"
              :label="item.zoneName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="footer">
        <div @click="cancel">取消</div>
        <div @click="submit">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import { getToken } from "@/utils/cookie";
export default {
  name: "backend",
  props: {},
  components: {},
  data() {
    return {
      // 区域
      valueRegion: "",
      optionRegion: [],
      // 单价
      valueNumber: "1",
      // 车牌号
      valueCar: "",
      optionCar: [],
      // 人员
      valuePeople: "",
      optionPeople: [],
      // 部门
      valueDepament: "",
      // 管理区域
      valueManage: [],
      optionManage: [],
      // 表格数据
      tableData: [],
      // 表格动态高度
      height: window.innerHeight / 2.5,
      tabIndex: 1,
      token: getToken(),
    };
  },
  created() {},
  mounted() {
    this.getPeople();
    this.getManage();
    this.getCar();
  },
  methods: {
    // 切换tab
    tabClick(type) {
      this.tabIndex = type;
      // this.getPeople();
      // this.getManage();
      // this.getCar();
      // if(type == 2){
      // }
    },
    // 查询厂务人员
    getPeople() {
      apis.getActiveUsersCarAdmins().then((data) => {
        if (data.code == 200) {
          this.optionPeople = data.data;
        }
      });
    },
    // 查询所有区域
    getManage() {
      apis
        .queryCarZoneByPageList({
          pageSize: "999",
          page: 1,
        })
        .then((data) => {
          if (data.code == 200) {
            console.log(data.data,'--------------');
            
            this.optionManage = data.data;
            this.getRegion(data.data);
          }
        });
    },
    // 查询区域
    getRegion(list) {
      apis
        .queryCarAdminZoneByPageList({
          pageSize: "999",
          page: 1,
          empno: getToken(),
        })
        .then((data) => { 
          if (data.code === 200 && Array.isArray(data.data)) {
            const zones = data.data[0]?.zones || "";
            const str = zones.split(",").map(Number).filter(Boolean); // 确保转换为数字且过滤无效值

            // 使用filter和includes优化双重遍历
            const result = list.filter((item1) => str.includes(item1.id));

            this.optionRegion = result;

            // 如果有结果，设置默认选项
            if (this.optionRegion.length > 0) {
              this.valueRegion = this.optionRegion[0].id;
              this.valueNumber = this.optionRegion[0].priceMl;
              this.getCarSearch();
            }
          }
        });
    },
    // 查询所有车辆
    getCar() {
      const params = {
        pageSize: "999",
        page: 1,
        carState: 0,
        zoneType: "0",
      };
      apis.queryCarListInfo(params).then((data) => {
        if (data.code == 200) {
          this.optionCar = data.data.list;
        }
      });
    },
    // 查询区域车辆
    getCarSearch() {
      this.tableData = []
      const params = {
        pageSize: "999",
        page: 1,
        carState: 0,
        zoneId: this.valueRegion,
      };
      apis.queryCarListInfo(params).then((data) => {
        if (data.code == 200) {
          const res = data.data.list;
          for (let i = 0; i < res.length; i++) {
            this.tableData.push({
              zoneName: res[i].zoneName,
              id: res[i].id,
              carBrandText: res[i].carBrand,
            });
          }
          // this.optionCar = data.data.list
        }
      });
    },
    //改变用车区域
    changeRegion(val){
      const result = this.optionRegion.find((item) => item.id == val);
      console.log(result,'result');
      
      this.valueNumber = result.priceMl;
      
      this.getCarSearch();
    },
    // 改变厂务人员
    changePeople(val) {
      const list = this.optionPeople.find((item) => item.username == val);
      this.valueDepament = list.position;
      apis
        .queryCarAdminZoneByPageList({
          pageSize: "999",
          page: 1,
          empno: val,
        })
        .then((data) => {
          console.log(data, "data");
          if (data.code == 200) {
            const zones = data.data[0]?.zones;
            this.valueManage =
              zones && zones.split(",").map((item) => Number(item));
          }
        });
    },
    // 删除
    handleDel(row) {
      const ind = this.tableData.findIndex((item) => item.carBrandText == row.carBrandText);
      if (ind != -1) {
        this.tableData.splice(ind, 1);
      }
    },
    // 添加区域车辆
    pushTable() {
      const showMessage = (message) => {
        this.$message({
          type: "warning", // success, error, warning
          message,
          duration: 2000,
        });
      };
      const flag = this.tableData.some(
        (item) => item.id == this.valueCar
      );
      const region = this.optionRegion.find(
        (item) => item.id == this.valueRegion
      );
      const car = this.optionCar.find((item) => item.id == this.valueCar);
      if (flag) {
        showMessage("该区域已添加该车牌号");
      } else if (!this.valueRegion) {
        showMessage("请选择区域");
      } else if (!this.valueCar) {
        showMessage("请选择车牌号");
      } else if (!this.valueNumber) {
        showMessage("请输入单价");
      } else {
        this.tableData.push({
          zoneName: region.zoneName,
          id: this.valueCar,
          carBrandText: car.carBrand,
        });
      }
    },
    // 提交
    submit() {
      if (this.tabIndex == 2) {
        if (!this.valuePeople) {
          this.$message({
            type: "warning", // success error warning
            message: "请选择厂务人员",
            duration: 2000,
          });
        } else {
          const params = {
            empno: this.valuePeople,
            zones: this.valueManage.join(","),
          };
          apis.zoneAddOrUpdate(params).then((data) => {
            if (data.code == 200) {
              this.$message({
                type: "success", // success error warning
                message: "添加成功",
                duration: 2000,
              });
              this.$router.go(-1);
            }
          });
        }
      } else if (this.tabIndex == 1) {
        if (!this.valueNumber) {
          this.$message({
            type: "warning", // success error warning
            message: "请输入单价",
            duration: 2000,
          });
        } else {
          const params = {
            zoneId: this.valueRegion,
            priceMl: this.valueNumber,
            vehicleInfos: [],
          };
          this.tableData.length > 0 && this.tableData.forEach((item) => {
            params.vehicleInfos.push({ id: item.id });
          })
          // params.vehicleInfos = JSON.stringify(params.vehicleInfos);
          apis.batchUpdate(params).then((data) => {
            if (data.code == 200) {
              this.$message({
                type: "success", // success error warning
                message: "添加成功",
                duration: 2000,
              });
              this.$router.go(-1);
            }
          });
        }
      }
    },
    // 返回
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
  .footer {
    width: 100%;
    bottom: 0;
    left: 0;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
  .footer {
    width: 276px * $zoom;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
.user_container {
  min-height: 100vh;
  margin: auto;
  font-size: 28px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .container {
    width: 100%;
    height: 100vh;
    position: relative;
  }
  .header {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      padding: 15px 40px;
      border: 1px solid rgba(29, 164, 121, 1);
      color: rgba(78, 162, 124, 1);
    }
    div:nth-child(1) {
      border-right: none;
      border-radius: 10px 0 0 10px;
    }
    div:nth-child(2) {
      border-radius: 0 10px 10px 0;
    }
    .active {
      color: #fff;
      background: rgba(29, 164, 121, 1);
    }
  }
  .content {
    background: #fff;
    padding: 30px;
    height: 80vh;
    padding-bottom: 20px;
    // overflow: auto;
    .filed_label {
      margin-bottom: 20px;
      span {
        font-size: 22px;
        color: #999;
      }
    }
    .filed_input {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      ::v-deep {
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
        }
        .el-input__inner {
          height: 65px;
          background: rgba(243, 244, 247, 1);
          border: none;
          //   border-radius: 10px;
        }
        .el-input-group__append {
          border: none;
          background: rgba(243, 244, 247, 1);
          border-radius: none;
          color: #000;
          font-size: 29px;
        }
        .el-button {
          height: 65px;
          width: 120px;
          margin-left: 20px;
          color: #fff;
          background: rgba(78, 162, 124, 1);
          border: none;
          border-radius: 10px;
        }
      }
    }
    .filed_table {
      ::v-deep {
        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        thead th {
          height: 80px;
          background: rgba(247, 249, 250, 1);
        }
        tbody tr {
          height: 80px;
        }
        .el-table__body {
          width: 100% !important;
        }

        .el-table th.gutter {
          display: none;
          width: 0;
        }

        .el-table colgroup col[name="gutter"] {
          display: none;
          width: 0;
        }

        .el-table--scrollable-y .el-table__body-wrapper {
          &::-webkit-scrollbar {
            width: 0 !important;
          }
        }
      }
    }
  }
  .footer {
    // width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    position: fixed;
    div:nth-child(1) {
      width: 38%;
      height: 100%;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      background: #fff;
    }
    div:nth-child(2) {
      width: 62%;
      height: 100%;
      background: rgba(78, 162, 124, 1);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
    }
  }
}
</style>
